import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';

const wrap: CSSObject = {
  fontSize: '14px',
  minWidth: '180px',
  fontWeight: 600,
  color: theme.color.grey700,
  [mobile]: {
    minWidth: 0,
    fontSize: 13,
    color: theme.color.grey600,
  },
};

export { wrap };
